<template>
  <div class="expand-section-container">
    <div class="expand-section" ref="expand-section" :class="{faded:isCollapsable && !collapsed}" :style="getStyle">
      <slot></slot>
    </div>
    <div v-if="isCollapsable && !collapsed" class="flex-center">
      <div @click="collapsed = !collapsed" class="badge badge-primary py-1 px-4 expand-button">Show More <i class="fas fa-caret-down"></i></div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isCollapsable: false,
        collapsed: false,
        originalHeight: 0
      }
    },
    props: {
      elemHeight: Number
    },
    mounted() {
      this.originalHeight = this.$refs['expand-section'].offsetHeight
      this.isCollapsable = this.$refs['expand-section'].offsetHeight > this.elemHeight ? true : false
    },
    computed: {
      getStyle() {
        if (this.isCollapsable) {
          return !this.collapsed ? `height: ${this.elemHeight}px;` : `height: ${this.originalHeight}px;`
        }
      }
    }
  }
</script>
